import { z } from "zod";

export const checkChargeICafeSchema = z.object({
  existSession: z.boolean(),
  iCafeId: z.string(),
  reason: z.string().optional(),
});

export type CheckChargeICafeType = z.infer<typeof checkChargeICafeSchema>;
